import { useState } from 'react';

import { showAlert } from 'components/shared/Alert/Alert';

const useCopy = ({ isText = true, alert = true } = {}) => {
  const [copyText, setCopyText] = useState(isText ? 'Copy' : '');

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopyText('Copied!');
        setTimeout(() => setCopyText(isText ? 'Copy' : ''), 2000);
        if (alert) {
          showAlert({
            title: 'Copied to clipboard!',
            color: 'success',
            duration: 500
          });
        }
      })
      .catch(() => {
        setCopyText('Failed to copy!');
        if (alert) {
          showAlert({
            title: 'Failed to copy!',
            color: 'error',
            duration: 500
          });
        }
      });
  };

  return { copyText, copyToClipboard };
};

export default useCopy;
